import Vue from 'vue';
import type { Module } from 'vuex';
import { ConfigObj, IConfig } from '../../entities/config-entity';

export const namespace = 'appState';
export type IMessageType = 'success' | 'error' | 'warning' | 'info';

interface IMessage {
	type: IMessageType;
	body: string;
	header?: string;
	html?: string;
}

export const actionTypes = {
	SET_USER_LOCALE: 'SET_USER_LOCALE',
	GET_REQUEST: 'GET_REQUEST',
	POST_REQUEST: 'POST_REQUEST',
	PUT_REQUEST: 'PUT_REQUEST',
	DELETE_REQUEST: 'DELETE_REQUEST',
};

export interface IAppUiState {
	messages: IMessage[];
	loading: Record<string, boolean>;
	config: ConfigObj;
	vars: ConfigObj;
}

export type AppLoading = Record<string, boolean>;

export default function appStore(): Module<IAppUiState, any> {
	return {
		namespaced: true,
		state: () => ({
			messages: [],
			loading: {},
			config: {},
			vars: {},
		}),
		actions: {
			[actionTypes.SET_USER_LOCALE](state, locale): void {
				this.$api.locale = locale;
			},
			async [actionTypes.GET_REQUEST](state, ...args: any): Promise<any> {
				const res = await this.$api.agent.transport.get(...args);
				return res;
			},
			async [actionTypes.POST_REQUEST](state, ...args: any): Promise<any> {
				const res = await this.$api.agent.transport.post(...args);
				return res;
			},
			async [actionTypes.PUT_REQUEST](state, ...args: any): Promise<any> {
				const res = await this.$api.agent.transport.put(...args);
				return res;
			},
			async [actionTypes.DELETE_REQUEST](state, ...args: any): Promise<any> {
				const res = await this.$api.agent.transport.delete(...args);
				return res;
			},
		},
		mutations: {
			setNotification: (state, message: IMessage) => {
				state.messages.push(message);
			},
			setLoading: (state, loading: AppLoading) => {
				Object.keys(loading).forEach((key: string) => {
					Vue.set(state.loading, key, loading[key]);
				});
			},
			setConfig: (state, config: IConfig) => {
				state.config = config.config;
				state.vars = config.var;
			},
		},
		getters: {
			config: ({ config }): ConfigObj => config,
			vars: ({ vars }): ConfigObj => vars,
			loadersMap: ({ loading }) => loading,
			appLoading: ({ loading }) =>
				Object.keys(loading)
					.map((k) => ({ key: k, state: loading[k] }))
					.filter((i) => i.state),
		},
	};
}
